import { ReadonlyRepositoryObjectService, Result } from '@softline/core';
import { computed, inject, Injectable, Signal, signal } from '@angular/core';
import { Supplier } from '@softapps/wws/core';
import {
  BauprofiSupplierQuery,
  BauprofiSupplierRepository,
} from '../repositories/bauprofi-supplier.repository';

@Injectable()
export class BauprofiSupplierService extends ReadonlyRepositoryObjectService<
  Supplier,
  Result<Supplier>,
  BauprofiSupplierQuery
> {
  readonly configParams = signal<Signal<BauprofiSupplierQuery | undefined>>(
    signal(undefined)
  );

  override params = computed(() => {
    return {
      id: this.configParams()()?.id,
    };
  });

  constructor() {
    super(inject(BauprofiSupplierRepository));
  }

  setSupplierParams(configParams: Signal<BauprofiSupplierQuery | undefined>) {
    this.configParams.set(configParams);
  }

  protected override getValue(result: Result<Supplier> | null | undefined): Supplier {
    return result as any;
  }
}
